import state from './moduleBrandState.js';
import mutations from './moduleBrandMutations.js';
import actions from './moduleBrandActions.js';
import getters from './moduleBrandGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
